<template>
	<component v-if="notMasked" :is="componentOfPart(mk.part)" :part="partRef(mk.part)" :data="localData"
			   :readonly="readonly" :viewmode="viewmode"></component>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import {computed, defineProps} from "vue";
import {injectMaskingLib} from "../Masking";
import type {JoinMasked, Masked} from "@t/fd/layout/Masked";

const untypedProps = defineProps({
	...containerProps,
});

const props = untypedProps as ContainerProps;
const mk = computed<JoinMasked>(() => props.part as JoinMasked);
const { componentOfPart, partRef, localData, ro, vm, visible, errors } = useContainer(props);
const mlib = injectMaskingLib();

const notMasked = computed(() => {
	if (visible.value) {
		return !mlib.joinEvaluate(mk.value.targets, localData.value, vm.value) || errors.value.length > 0;
	} else return false;
});

</script>

<style>

</style>